const ext = window.navigator.userAgent.match(/Android/) ? '.ogg' : '.mp3';

export const Config = {
    // パラメータの使用（false でも一部使用）
    USE_PARAM: true,

    // ローカルストレージ名
    STORAGE_KEY: 'degitalenglishplus-taiken',

    // データのkeyと初期値
    INIT_STORAGE_DATA: {
        isFirstVisit: true,
    },

    SOUND_ASSETS: {
        'se': { src: [`./assets/sound/se/close${ext}`], loop: false, volume: 1.0 },
        'bgm': { src: [`./assets/sound/bgm/bgm${ext}`], loop: true, volume: 0.5 },
        'top': { src: [`./assets/sound/na/top${ext}`], loop: false, volume: 1.0 },
        'parent-modal': { src: [`./assets/sound/na/parent-modal${ext}`], loop: false, volume: 1.0 },
    },
};
